import { render, staticRenderFns } from "./PatrolCarousel.vue?vue&type=template&id=011ed8f0&scoped=true"
import script from "./PatrolCarousel.vue?vue&type=script&lang=js"
export * from "./PatrolCarousel.vue?vue&type=script&lang=js"
import style0 from "./PatrolCarousel.vue?vue&type=style&index=0&id=011ed8f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011ed8f0",
  null
  
)

export default component.exports